module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c2/cv_2_sp_b4341b8984cf177a905d1e3ee4f64f29.jpg";